$(function() {

    var calendarLink = $("#courses-calendar-link-week");

    calendarLink.on("click", function() {

        $("#calendar-modal").load("/calendar", function() {

            var options = {
                format: "mm/dd/yyyy",
                weekStart: 1,
                todayHighlight: true,
                calendarWeeks: true,
                language: ebusy.locale.replace("_", "-"),
                templates: {
                    leftArrow: '<i class="icon-chevron-left"></i>',
                    rightArrow: '<i class="icon-chevron-right"></i>'
                }
            };

            if (!ebusy.userLevel || (ebusy.userLevel !== 'OPERATOR' && ebusy.userLevel !== 'ADMINISTRATOR' && ebusy.userLevel !== 'GOD')) {
                options.startDate = "+0d";
            }

            // monkey patch bootstrap-datepicker since there seems to be no
            // other way to execute code after the datepicker is rendered,
            // see https://github.com/uxsolutions/bootstrap-datepicker/pull/1605
            var originalFill = $.fn.datepicker.Constructor.prototype.fill;
            $.fn.datepicker.Constructor.prototype.fill = function() {
                originalFill.call(this);

                $("#calendar-modal")
                    .find(".day.active")
                    .closest("tr")
                    .addClass("active-week")
                    .siblings("tr")
                    .removeClass('active-week');
            }

            $(".modal-content", $(this))
                .datepicker(options)
                .on("changeDate", function(selectedDate) {

                    var selectedDatePart = "?selectedDate=" + selectedDate.format(0, "mm/dd/yyyy");

                    var courseViewParam = ebusy.getGetParameter("courseView");
                    var courseViewPart = courseViewParam ? "&courseView=" + courseViewParam : "";

                    var currentCoursePlanParam = ebusy.getGetParameter("currentCoursePlan");
                    var currentCoursePlanPart = (currentCoursePlanParam !== null) ?
                        "&currentCoursePlan=" + currentCoursePlanParam :
                        "";

                    location.href = calendarLink.data("url") + selectedDatePart + courseViewPart + currentCoursePlanPart;
                });

            $("td.cw", $(".modal-content")).on("click", function() {

                var firstDayOfWeek = new Date($(this).next("td.day").data("date"));

                $(".modal-content").datepicker("setDate", firstDayOfWeek);
            });

            $("#calendar-modal").modal();
        });
    });

});
